import { DynamicForm, FieldVariant } from '../../../components/form-builder/form-builder.types';
import { of } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

export const getPasswordFormObject = (passwordForm: FormGroup, translate: TranslateService): DynamicForm => {
  const newPasswordField = {
    label: translate.instant('profile.form.password.new'),
    variant: FieldVariant.PASSWORD,
    isRequired: true,
    props: {
      value: of(''),
      placeholder: translate.instant('profile.form.password.new'),
      onChange: (value: string) => {
        passwordForm.get('newPassword')?.patchValue(value);
      },
    },
  };

  const confirmPasswordField = {
    label: translate.instant('profile.form.password.confirm'),
    variant: FieldVariant.PASSWORD,
    isRequired: true,
    props: {
      value: of(''),
      placeholder: translate.instant('profile.form.password.confirm'),
      onChange: (value: string) => {
        passwordForm.get('confirmPassword')?.patchValue(value);
      },
    },
  };

  return {
    title: translate.instant('profile.form.password.title'),
    description: translate.instant('profile.form.password.description'),
    isHeaderHidden: false,
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [newPasswordField, confirmPasswordField],
            class: 'grid-cols-2',
          },
        ],
      },
    ],
  };
};
